import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table-container" }
const _hoisted_2 = { style: {"display":"grid","grid-template-columns":"55% 35% 10%","grid-gap":"5px","margin":"0","min-width":"100px"} }
const _hoisted_3 = {
  key: 0,
  class: "highlight",
  style: {"grid-column":"3","max-width":"20px"}
}
const _hoisted_4 = {
  key: 1,
  style: {"grid-column":"3","max-width":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SaveFilterPrompt = _resolveComponent("SaveFilterPrompt")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_ShareFilterPrompt = _resolveComponent("ShareFilterPrompt")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_orderable_advanced_table = _resolveComponent("orderable-advanced-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      modelValue: _ctx.showSavePrompt,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showSavePrompt) = $event)),
      centered: "",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SaveFilterPrompt, {
          "configured-search": _ctx.filterState,
          "table-key": "ProposalData",
          onSave: _ctx.saveSearch
        }, null, 8, ["configured-search", "onSave"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_b_modal, {
      fullscreen: "",
      modelValue: _ctx.showSharePrompt,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showSharePrompt) = $event)),
      centered: "",
      "hide-footer": "",
      "hide-header": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ShareFilterPrompt, {
          "table-key": "ProposalData",
          onShare: _ctx.shareSearch,
          onCancel: _ctx.hideSharePrompt
        }, null, 8, ["onShare", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_orderable_advanced_table, {
        id: "proposalTable",
        "table-array": [_ctx.table],
        loading: _ctx.filterSearchState.loading,
        toggleRow: true,
        "dynamic-columns": "",
        "show-pagination": "",
        "sticky-header": "calc(100vh - 86px)",
        "per-page": 50,
        "side-pane-options": {hideHeader:true, width: '400px'}
      }, {
        action: _withCtx((actionProps) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_b_button, {
              style: {"grid-column":"1","font-size":".6em","padding":"5px"},
              variant: "secondary",
              onClick: ($event: any) => (_ctx.emitSelection(actionProps.item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.actionName), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_b_button, {
              style: {"grid-column":"2","font-size":".6em","padding":"5px"},
              variant: "secondary",
              onClick: ($event: any) => (_ctx.openCopyTool(actionProps.item))
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Copy ")
              ])),
              _: 2
            }, 1032, ["onClick"]),
            (actionProps.item.urgencyCode && actionProps.item.urgencyCode.toLowerCase() == 'urgent')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4))
          ])
        ]),
        _: 1
      }, 8, ["table-array", "loading"])
    ])
  ], 64))
}